<div class="flex gap-20 mb-20 mt-10">
  <p>
    Office email addresses are for employees of organizations that have a relationship with the Department of Education.  Department communications related to the work you do for the organization are sent to your office email address, not your personal email address.
    <br />
    You have multiple office email addresses in our records, which is common if you work for multiple organizations.  Each office email address must be associated with an organization, and emails relevant to that organization will be sent to the correct email address.
  </p>
</div>
<div class="flex gap-20 mb-20 mt-10">
  <button title="Add New Email" (click)="toggleshowAddNew()" class="rounded-full hover-blue-800 black">
    <div class="btn-txt font-white">Add New Email</div>
  </button>
</div>
<!-- This is the add new form -->
@if (showAddNew) {
  <form [formGroup]="newemailform">
    <div class="p-20 relative mt-20">
      <div class="inline-text-field-container flex-row gap-20 adjust">
        <div class="ds-text-field">
          <input class="ds-text-field__input" id="emailId" type="text" name="emailId" autocomplete="off" value=""
            required="" email="true" [(ngModel)]="emailId" formControlName="emailId"
            (change)="onOfficeEmailBlur($event)">
            <label for="address" class="ds-floating-label ">*Enter New Office Email</label>
            <div class="field-line-ripple blue"></div>
            @if (newemailform.get('emailId').invalid && newemailform.get('emailId').errors && (newemailform.get('emailId').dirty || newemailform.get('emailId').touched)) {
              <div
                >
                @if (newemailform.get('emailId').hasError('required')) {
                  <span id="newemail-errmsg"
                  class="error errmsg">Enter Office Email</span>
                }
                @if (newemailform.get('emailId').hasError('email')) {
                  <span class="error errmsg">Please enter a valid
                  email</span>
                }
              </div>
            }
            @if (isDuplicateEmail) {
              <span class="custom-error">Email Already Exists</span>
            }
          </div>
          <div class="ds-text-field">
            <input class="ds-text-field__input" id="remailId" type="text" name="remailId" autocomplete="off" required=""
              [compareEqual]="emailId" [(ngModel)]="remailId" formControlName="remailId">
              <label for="address2" class="ds-floating-label">*Re-Enter New Office Email</label>
              <div class="field-line-ripple blue"></div>
              @if (newemailform.get('remailId').invalid && newemailform.get('remailId').errors && (newemailform.get('remailId').dirty || newemailform.get('remailId').touched)) {
                <div>
                  @if (newemailform.get('remailId').hasError('required')) {
                    <span id="newemail2-errmsg"
                    class="error errmsg">Re-enter Office Email</span>
                  }
                </div>
              }
              @if (newemailform.get('remailId').invalid && newemailform.get('remailId').errors && (newemailform.get('remailId').dirty || newemailform.get('remailId').touched)) {
                <div>
                  @if (!newemailform.get('remailId').hasError('required') && newemailform.get('remailId').hasError('compareEqual')) {
                    <span
                    id="newemail2-errcomparemsg" class="error errmsg">Email do not match</span>
                  }
                </div>
              }
              @if (emailId && remailId && emailId == remailId) {
                <div class="check">
                  <i class="fas fa-check"></i>
                </div>
              }
            </div>
          </div>
          <div class="inline-text-field-container flex-row gap-20 radio-form">
            <div class="container radio-button radio-bg new">
              <input id="pp-radio-new1" name="type" type="radio" value="public" formControlName="type">
              <label class="gray-300  click-white" for="pp-radio-new1">
                Public
              </label>
            </div>
            <div class="container radio-button radio-bg new border-right pr-20">
              <input id="pp-radio-new2" name="type" type="radio" value="private" formControlName="type">
              <label class="gray-300  click-white" for="pp-radio-new2">
                Private
              </label>
            </div>
            <div class="container radio-button radio-bg new">
              <input id="primary-radio-new" name="isPrimary" type="radio" value="true" formControlName="isPrimary">
              <label class="gray-300  click-white" for="primary-radio-new">
                Primary
              </label>
            </div>
          </div>
          <div class="container flex gap-20 justify-end mt-20">
            <button title="Cancel" (click)="togglehideHomeAddNew()" id=""
              class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
              <div class="btn-txt font-red bold">Cancel</div>
            </button>
            <button title="Add New Office Email" class="rounded-full hover-blue-800 black" (click)="addNewEmail()" [disabled]="!newemailform.valid">
              <div class="btn-txt font-white">Add New Office Email</div>
            </button>
          </div>
        </div>
      </form>
      <div class="display-block mt-20">
        <hr>
        </div>
      }
      <div>
        <p>
          <b>Private or Public</b>
        </p>
        <p>
          Office email addresses are typically published in the Ohio Educational Directory System (OEDS), an application that allows anyone to look up information about Ohio’s K-12 organizations.  This makes sense in many cases, but you can flag an office email address as Private to keep it from being shared in OEDS.
        </p>
      </div>
      <div class="flex-row">
        <p>
          <b>Primary</b>
        </p>
        <p>
          If you have multiple office email addresses, one (and only one) of them must be identified as the primary email address.  The primary address is used for Department messages that are relevant to all organizations, or for organizations for which an organization specific office email address has not been provided.
        </p>
      </div>
      <div class="flex mt-20 justify-start gap-20">
        <i Class="fas fa-check"></i>
        Used Email
        <i Class="fas fa-minus-circle"></i>
        Unused Email
      </div>
      <div class="flex-row pb-20 mt-10">
        <div class="card fluid">
          <div class="card__content">
            <table class="table-ode">
              <thead>
                <tr>
                  <th style="width:38px;"></th>
                  <th>Email</th>
                  <th class="show-desktop" style="width:235px;">Private or Public</th>
                  <th class="show-desktop" style="width:129px;">Primary</th>
                  <th class="show-desktop" style="width:68px;"></th>
                </tr>
              </thead>
              <tbody>
                @for (em of emailList; track em; let i = $index) {
                  <tr>
                    <td>
                      <!-- This is a toggle of css classes that will switch from used to unused depending on selecting an email -->
                      <i [ngClass]="em.isMapped==false?'fas fa-minus-circle':'fas fa-check'"></i>
                    </td>
                    <td>
                      <span class="bold-name">
                        {{em.email}}
                      </span>
                      <div class="show-mobile mt-10">
                        <div class="flex">
                          <div class="mr-5">
                            <div class="container radio-button radio-bg new">
                              <input id="pp-radio-1_{{i}}" name="pp-radio_{{i}}" type="radio" value="public"
                                [attr.checked]="em.privateFlag== false ? true : null" [ngClass]="em.privateFlag== false ? 'radio-checked' : ''"
                                (change)="updatetype(em.oedsEmailKey,em.email,'public')">
                                <label class="gray-300  click-white" for="pp-radio-1_{{i}}">
                                  Public
                                </label>
                              </div>
                            </div>
                            <div class="mr-5">
                              <div class="container radio-button radio-bg new">
                                <input id="pp-radio-2_{{i}}" name="pp-radio_{{i}}" type="radio" value="private"
                                  [attr.checked]="em.privateFlag== true ? true : null" [ngClass]="em.privateFlag== true ? 'radio-checked' : ''"
                                  (change)="updatetype(em.oedsEmailKey,em.email,'private')">
                                  <label class="gray-300  click-white" for="pp-radio-2_{{i}}">
                                    Private
                                  </label>
                                </div>
                              </div>
                              <div class="mr-10">
                                <div class="container radio-button radio-bg new">
                                  <input id="primary-radio-1_{{i}}" name="primary" type="radio" value="primary"
                                    [attr.checked]="em.primaryFlag== true ? true : null" [ngClass]="em.primaryFlag== true ? 'radio-checked' : ''"
                                    (change)="updateisPrimary(em.oedsEmailKey,em.email)">
                                    <label class="gray-300  click-white" for="primary-radio-1_{{i}}">
                                      Primary
                                    </label>
                                  </div>
                                </div>
                                <div>
                                  @if (!em.primaryFlag && !em.isMapped) {
                                    <button (click)="deleteemail(em.oedsEmailKey,em.email,i)" id=""
                                      title="Delete Email" style="padding: 0 7px;"
                                      class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                                      <div class="icon trash icon-red font-20">
                                        <i class="fas fa-trash"></i>
                                      </div>
                                    </button>
                                  }
                                </div>
                              </div>
                            </div>
                          </td>
                          <td class="show-desktop">
                            <div class="flex">
                              <span class="pr-10">
                                <div class="container radio-button radio-bg new">
                                  <input id="pp-radio-1_{{i}}" name="pp-radio_{{i}}" type="radio" value="public"
                                    [attr.checked]="em.privateFlag== false ? true : null" [ngClass]="em.privateFlag== false ? 'radio-checked' : ''"
                                    (change)="updatetype(em.oedsEmailKey,em.email,'public')">
                                    <label class="gray-300  click-white" for="pp-radio-1_{{i}}">
                                      Public
                                    </label>
                                  </div>
                                </span>
                                <span>
                                  <div class="container radio-button radio-bg new">
                                    <input id="pp-radio-2_{{i}}" name="pp-radio_{{i}}" type="radio" value="private"
                                      [attr.checked]="em.privateFlag== true ? true : null" [ngClass]="em.privateFlag== true ? 'radio-checked' : ''"
                                      (change)="updatetype(em.oedsEmailKey,em.email,'private')">
                                      <label class="gray-300  click-white" for="pp-radio-2_{{i}}">
                                        Private
                                      </label>
                                    </div>
                                  </span>
                                </div>
                              </td>
                              <td class="show-desktop">
                                <div class="container radio-button radio-bg new">
                                  <input id="primary-radio-1_{{i}}" name="primary-radio" type="radio" value="primary"
                                    [attr.checked]="em.primaryFlag== true ? true : null" [ngClass]="em.primaryFlag== true ? 'radio-checked' : ''"
                                    (change)="updateisPrimary(em.oedsEmailKey,em.email)">
                                    <label class="gray-300  click-white" for="primary-radio-1_{{i}}">
                                      Primary
                                    </label>
                                  </div>
                                </td>
                                <td class="show-desktop">
                                  @if (!em.primaryFlag && !em.isMapped) {
                                    <button (click)="deleteemail(em.oedsEmailKey,em.email,i)" id=""
                                      title="Delete Email" style="padding: 0 7px;"
                                      class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                                      <div class="icon trash icon-red font-20">
                                        <i class="fas fa-trash"></i>
                                      </div>
                                    </button>
                                  }
                                </td>
                              </tr>
                              <!-- This is the delete confirmation located in the shared folder -->
                              @if (showDelete[i]) {
                                <ng-container (doCancel)="canceldelete(i)">
                                  <tr>
                                    <td class="inset-blur" colspan="5">
                                      <app-delete-confirmation (doCancel)="canceldelete(i)" (doDelete)="delete()"></app-delete-confirmation>
                                    </td>
                                  </tr>
                                </ng-container>
                              }
                            }

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  @if (npEmailCollection && npEmailCollection.length>=1) {
                    <div>
                      <div>
                        <p>
                          <b>Add An Organizations Email Mapping</b>
                        </p>
                        <p>
                          You are associated with multiple organizations.  For each organization, you may select one of your office email addresses to receive emails specific to that organization.  If one is not specified, emails will go to the primary email address.
                        </p>
                      </div>
                      <div class="flex mb-10">
                        <div class="flex justify-end font-required form mt-10 basis-100"><b>*Required</b></div>
                      </div>
                      <div>
                        <div class="select-container org-name chevron border-bottom border-gray-600">
                          <select class="ds-select-field rounded-4 hover-gray-300" (change)="setSelectedOrg($event.target)" required>
                            <option value="" disabled selected></option>
                            @for (org of cService.orgList; track org) {
                              <option value="{{ org.orgId}}">
                                {{ org.orgName }}
                              </option>
                            }
                          </select>
                          <label class="ds-floating-label">Select Organization</label>
                        </div>
                      </div>
                      <div class="flex mb-10">
                        <div class="flex justify-end font-required form mt-10 basis-100">
                          <button (click)="toggleshowOrgForm()" class="rounded-full hover-blue-800 black" [disabled]="!isOrgSelected">
                            <div class="btn-txt font-white">Select Org</div>
                          </button>
                        </div>
                      </div>
                      @if (showOrgForm) {
                        <div class="fade width-full border-bottom border-gray-600 mb-20 pb-10">
                          <div class="bold mb-10">
                            Select An Email For this Org
                          </div>
                          <div class="flex org">
                            <div class="justify-start basis-50">
                              <div class="display-block">
                                <span>
                                  Org Name:
                                </span>
                                <span class="bold">
                                  {{sOrgname}}
                                </span>
                              </div>
                              <div class="display-block">
                                <span>
                                  IRN:
                                </span>
                                <span class="bold">
                                  {{sOrgIrn}}
                                </span>
                              </div>
                            </div>
                            <div class="basis-50">
                              <!--(ngModelChange)="updateIsUnused(org.email, org.orgId)"-->
                              <div class="select-container chevron border-bottom border-gray-600">
                                <select class="ds-select-field rounded-4 hover-gray-300"
                                  (change)="updateIsUsed($event.target,sOrgId)" required>
                                  <option value="" disabled selected></option>
                                  <!-- <option value="0">None</option> -->
                                  @for (npemail of npEmailCollection; track npemail) {
                                    <option value="{{ npemail.email }}">
                                      {{ npemail.email }}
                                    </option>
                                  }
                                </select>
                                <label class="ds-floating-label">*Select Email</label>
                              </div>
                            </div>
                          </div>
                          <div class="flex mb-10">
                            <div class="flex justify-end font-required form mt-10 basis-100">
                              <button (click)="alert()" class="rounded-full hover-blue-800 black" [disabled]="!isOrgAdded">
                                <div class="btn-txt font-white">Add Org Email Mapping</div>
                              </button>
                            </div>
                          </div>
                        </div>
                      }
                      @if (action==='Alert') {
                        <app-alert [messageHeading]="sMessageHead" [message]="sMessage"></app-alert>
                      }
                      @if (orgEmailMapping.length>=1) {
                        <div class="flex-row pb-20 mt-20">
                          <div class="card fluid">
                            <div class="card__content">
                              <table class="table-ode org">
                                <thead>
                                  <tr>
                                    <th class="width-adjust">Org Name</th>
                                    <th class="show-desktop">IRN</th>
                                    <th class="show-desktop">Email</th>
                                    <th class="show-desktop" style="width:50px;"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (org of orgEmailMapping; track org; let i = $index) {
                                    <tr>
                                      <td>
                                        <span class="org-name bold-name">
                                          {{org.orgName}}
                                        </span>
                                        <div class="show-mobile font-13 org-mobile pl-5">
                                          IRN:{{org.orgIrnNo}}
                                        </div>
                                        <div class="show-mobile mt-10">
                                          <div class="select-container chevron border-bottom border-gray-600">
                                            <select class="ds-select-field rounded-4 hover-gray-300"
                                              (change)="updateIsUsed($event.target,org.orgId)" [(ngModel)]='org.email'>
                                              <option value="" selected>None</option>
                                              @for (npemail of npEmailCollection; track npemail) {
                                                <option value="{{ npemail.email }}">
                                                  {{ npemail.email }}
                                                </option>
                                              }
                                            </select>
                                            <label class="ds-floating-label">Select Email</label>
                                          </div>
                                        </div>
                                        <div class="show-mobile mt-10 mb-10">
                                          <button id="" title="Delete Org" style="padding: 0 7px;" (click)="updateIsUnused(org.email, org.orgId,org.emailId)"
                                            class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                                            <div class="icon trash icon-red font-20">
                                              <i class="fas fa-trash"></i>
                                            </div>
                                          </button>
                                        </div>
                                      </td>
                                      <td class="show-desktop">
                                        {{org.orgIrnNo}}
                                      </td>
                                      <td class="show-desktop">
                                        <!--(ngModelChange)="updateIsUnused(org.email, org.orgId,org.emailId)"-->
                                        <div class="select-container chevron border-bottom border-gray-600">
                                          <select class="ds-select-field rounded-4 hover-gray-300"
                                            (change)="updateIsUsed($event.target,org.orgId)" [(ngModel)]='org.email'>
                                            <option value="" selected>None</option>
                                            @for (npemail of npEmailCollection; track npemail) {
                                              <option value="{{ npemail.email }}">
                                                {{ npemail.email }}
                                              </option>
                                            }
                                          </select>
                                          <label class="ds-floating-label">Select Email</label>
                                        </div>
                                      </td>
                                      <td class="show-desktop">
                                        <button id="" title="Delete Org" style="padding: 0 7px;" (click)="updateIsUnused(org.email, org.orgId,org.emailId)"
                                          class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                                          <div class="icon trash icon-red font-20">
                                            <i class="fas fa-trash"></i>
                                          </div>
                                        </button>
                                      </td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }

                  <div id="duplicateEmail" class="modal-wrapper" role="dialog" aria-labelledby="duplicateEmail-heading"
                    aria-describedby="duplicateEmail-description" aria-hidden='true' tabindex="0" target="_blank">
                    <div class="modal-dialog">
                      <div class="modal-content white  border border-secondary">
                        <header>
                          <div class="modal-title" id="duplicateEmail-heading">
                            <h3><i Class="fas fa-minus-circle"></i> Email Already Exists</h3>
                          </div>
                        </header>
                        <div class="flex justify-end mt-30 mr-20">
                          <button title="Close" class="rounded-full hover-blue-800 black mobile" (click)="closeConfirmModal('duplicateEmail')">
                            <div class="btn-txt font-white">Close</div>
                          </button>
                        </div>
                      </div>
                      <a href="javascript:void(0)" role="button" class="modal_close modalkill" aria-label="Close this window"
                      (click)="closeConfirmModal('duplicateEmail')">close</a>
                    </div>
                  </div>
